"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _popup_container = _interopRequireDefault(require("../popup_container"));

var _reactJss = _interopRequireDefault(require("react-jss"));

var _popup_styles = _interopRequireDefault(require("../popup_styles"));

var _inactive_definition = _interopRequireDefault(require("./inactive_definition"));

var _definecomponent = require("../../../../utils/definecomponent");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// definition

/* ========== ~~~~~~~~~~ MESSAGE : POPUP : ON INACTIVITY MESSAGE : CHILD ~~~~~~~~~~ ========== */


var OnInActivityMessage = (0, _reactJss.default)(_popup_styles.default)(function (props) {
  return _react.default.createElement(_popup_container.default, {
    type: 'extendsession',
    title: 'We haven’t seen any activity in a while: are you still there?',
    buttonPrimary: {
      text: 'Yes',
      variant: 'primary',
      action: props.primaryAction
    },
    buttonSecondary: {} // Not being used but causes Popup to break if it is absent

  });
});
/* ========== ~~~~~~~~~~ DEFINE COMPONENT ~~~~~~~~~~ ========== */

(0, _definecomponent.defineComponent)(OnInActivityMessage, _inactive_definition.default, false);
/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */

var _default = OnInActivityMessage;
exports.default = _default;